import { render, staticRenderFns } from "./MiladiToShamsi.vue?vue&type=template&id=cbb05db6&scoped=true&"
import script from "./MiladiToShamsi.vue?vue&type=script&lang=js&"
export * from "./MiladiToShamsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb05db6",
  null
  
)

export default component.exports